export default __webpack_public_path__ + "static/media/pic10.13bee411.jpg";